import { Box, FormControl, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { rejectInvitationByToken } from "../../../api/invitations";
import { AppButton } from "../../../components/form";
import { FormHelperTextError } from "../../../components/form/errors";
import Logo from "../../../components/Logo";
import { useAppDispatch } from "../../../store";
import InvitationDeclineStatus from "./invitation-decline-status";

export default function InvitationDecline() {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");

  const token = searchParams.get("token");

  const handleReasonChange = (e) => {
    const value = e.target.value;
    setReason(value);
    if (value.trim()) {
      setReasonError("");
    }
  };

  const validateForm = () => {
    if (!reason.trim()) {
      setReasonError("Reason is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    if (!token) {
      setError(true);
      return;
    }

    setLoading(true);
    setError(false);

    try {
      const response = await dispatch(rejectInvitationByToken(token, reason.trim()));

      if (response?.success) {
        setSuccess(true);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return <InvitationDeclineStatus variant="invalid-token" />;
  }

  if (error) {
    return <InvitationDeclineStatus variant="error" />;
  }

  if (success) {
    return <InvitationDeclineStatus variant="success" />;
  }

  return (
    <Stack p={2} component="form" onSubmit={handleSubmit} maxWidth={500} margin="50px auto">
      <Box textAlign="center">
        <Logo />
      </Box>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
        }}
      >
        Decline Invitation
      </Typography>
      <FormControl
        fullWidth
        error={!!reasonError}
        variant="standard"
        margin="normal"
      >
        <TextField
          id="reason"
          name="reason"
          value={reason}
          placeholder="Enter reason for declining the invitation"
          onChange={handleReasonChange}
          variant="outlined"
          size="small"
          fullWidth
          multiline
          rows={4}
          aria-describedby="component-error-text-reason"
        />
        <FormHelperTextError
          id="component-error-text-reason"
          error={!!reasonError}
          helperText={reasonError}
        />
      </FormControl>

      <AppButton
        type="submit"
        loading={loading}
        fullWidth
        variant="contained"
        disabled={loading || !reason.trim()}
      >
        Decline Invitation
      </AppButton>
    </Stack>
  );
}

